// extracted by css-extract-rspack-plugin
export default {"datePickerButton":"wya8V5"};